export const fmtNumberBR = new Intl.NumberFormat('pt-BR');
export const fmtCurrencyBR = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
// Valor na moeda da venda (JPY sem centavos, MXN com). Código inválido: "ZZZ 10.00".
export const fmtCurrency = (code, value) => {
    const cur = (code || "BRL").toUpperCase();
    try {
        return new Intl.NumberFormat("pt-BR", { style: "currency", currency: cur }).format(Number(value) || 0);
    } catch {
        return `${cur} ${Number(value || 0).toFixed(2)}`;
    }
};
